import { HttpClient } from '@adapters/HttpClient';

export interface User {
  id: number;
  name: string;
  email: string;
}

export interface UsersPage {
  users: User[];
  nextPage?: number;
  hasMore: boolean;
  total: number;
}

export class UsersApiAdapter {
  constructor(private httpClient: HttpClient) {}

  async getUsersPaginated(
    filters: {
      searchTerm?: string;
      page?: number;
      limit?: number;
    } = {}
  ): Promise<UsersPage> {
    const { searchTerm = '', page = 1, limit = 100 } = filters;

    const params: Record<string, any> = {
      ...(searchTerm && { search: searchTerm }),
      page,
      per_page: limit,
    };

    const response = await this.httpClient.get<any>('/users', params);

    // 🎯 The API returns a direct array, not within response.data
    const users = Array.isArray(response) ? response : [];

    const result = {
      users,
      nextPage: undefined, // No pagination on this endpoint
      hasMore: false, // No more pages
      total: users.length, // Total is the number of loaded users
    };
    return result;
  }

  async getAll(): Promise<User[]> {
    const response = await this.getUsersPaginated({ limit: 1000 });
    return response.users;
  }
}
